import styled from 'styled-components'

export const NodeActionsWrapper = styled.div`
	display: flex;

	svg {
		margin-right: 8px;
	}
`
